import Vue from 'vue';
import Router from 'vue-router';
import config from './assets/js/conf/config';
import request from './assets/js/utils/request';
import store from './store';
import {
	canAccessLegacyPath,
	getAllowedChildren,
	getFirstLegacyLocation,
	getFirstNewUiLocation,
	getLegacyPermissionForPath,
	getNewUiLocation,
	getWorkbenchByRoute,
	resolveRequestedNewUiChild
} from './config/newUiPermissions';


Vue.use(Router);

const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch((err) => err)
}
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch((err) => err)
}

let ucmenu = []
function getUCmenu(){
	request.post(config.baseApi + "/business/base/getMenu").then((res)=>{
		if(res.status = 200){
			localStorage["ucmenu"]=JSON.stringify(res.data)
		}
	})
}

let router = new Router({
	mode: "history", //1、hash哈希：有#号。2、history历史：没有#号
	base: process.env.BASE_URL, //自动获取根目录路径
	scrollBehavior: (to, from, position) => {
		if (position) {
			return position
		} else {
			return {
				x: 0,
				y: 0
			}
		}
	},
	routes: [{
			path: "/",
			name: "index",
			component: () => import("./pages/newLanding"),
		},
		{
			path: "/mall",
			name: "mall",
			component: () => import("./pages/index"),
		},
		{
			path: "/about",
			name: "about",
			component: () => import("./pages/about"),
		},
		{
			path: "/login",
			name: "login",
			component: () => import("./pages/login"),
			meta: { guestOnly: true },
		},
		{
			path: "/register",
			name: "register",
			component: () => import("./pages/register"),
			meta: { guestOnly: true },
		},
		{
			path: "/user-agreement",
			name: "user agreement",
			redirect: "/user-service-agreement",
		},
		{
			path: "/user-service-agreement",
			name: "user service agreement",
			component: () => import("./pages/userAgreement"),
		},
		{
			path: "/privacy-policy",
			name: "privacy policy",
			component: () => import("./pages/privacyPolicy"),
		},
		{
			path: "/detail",
			name: "detail",
			component: () => import("./pages/detail")
		},
		{
			path: "/ucenter",
			name: "ucenter",
			component: () => import("./pages/newUcenter"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_uc_shop_manage",
			name: "ucenter shop manage",
			component: () => import("./pages/shopManage"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_finance_workbench",
			name: "new finance workbench",
			component: () => import("./pages/financeWorkbench"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_uc_reimbursement",
			name: "new uc reimbursement",
			component: () => import("./pages/reimburse"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_ops_workbench",
			name: "new ops workbench",
			component: () => import("./pages/opsWorkbench"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_ops_workbench_shop_details",
			name: "new ops workbench shop details",
			component: () => import("./pages/shopBoard/detail.vue"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_select_workbench",
			name: "new select workbench",
			component: () => import("./pages/selectWorkbench"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_cloud_workbench",
			name: "new cloud workbench",
			component: () => import("./pages/cloudWorkbench"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/ucenter_legacy",
			name: "ucenter legacy",
			redirect:'/new_uc_shop_manage',
			component: () => import("./pages/ucenter"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/workbench",
			name: "workbench",
			component: () => import("./pages/workbench"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_goods",
			name: "ucenter goods",
			redirect:'/new_uc_shop_manage',
			component: () => import("./pages/uc_goods"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_uc_goods",
			name: "ucenter goods legacy",
			component: () => import("./pages/myGoods"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_goods_workbench",
			name: "goods workbench",
			component: () => import("./pages/goodsWorkbench"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_presales_workbench",
			name: "presales workbench",
			component: () => import("./pages/presalesWorkbench"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_aftersales_workbench",
			name: "aftersales workbench",
			component: () => import("./pages/aftersalesWorkbench"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_system_workbench",
			name: "system workbench",
			component: () => import("./pages/systemWorkbench"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_uc_after_sales_detail",
			name: "aftersales detail",
			component: () => import("./pages/afterSalesDetail"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_goods_connect",
			name: "ucenter goods connect",
			component: () => import("./pages/uc_goods/connect"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_order",
			name: "ucenter order",
			redirect: "/new_presales_workbench",
			component: () => import("./pages/uc_orderNew"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_order_wx",
			redirect: "/new_presales_workbench",
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_uc_order",
			name: "ucenter order legacy",
			component: () => import("./pages/orderManage"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_order_relate",
			name: "ucenter order relate",
			component: () => import("./pages/uc_order/relate"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_order_detail",
			name: "ucenter order detail",
			component: () => import("./pages/uc_order/detail"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_order_aftersale",
			name: "ucenter order aftersale",
			component: () => import("./pages/uc_order/aftersale"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_order_detail_saled",
			name: "ucenter order detail saled",
			component: () => import("./pages/uc_order/saled"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_wallet",
			name: "ucenter wallet",
			redirect:'/new_finance_workbench',
			component: () => import("./pages/uc_wallet"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_uc_wallet",
			name: "ucenter wallet legacy",
			component: () => import("./pages/wallet"),
			meta:{auth:true,authority:true}
		},

		{
			path: "/uc_shangjia",
			name: "ucenter shangjia",
			redirect:'/new_cloud_workbench',
			component: () => import("./pages/uc_shangjia"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_uc_shangjia",
			name: "ucenter shangjia legacy",
			component: () => import("./pages/shelfStrategy"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_setting",
			name: "ucenter setting",
			redirect:'/new_system_workbench',
			component: () => import("./pages/uc_setting"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_uc_setting",
			name: "ucenter setting legacy",
			component: () => import("./pages/profile"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_extend",
			name: "ucenter extend",
			component: () => import("./pages/uc_extend"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_position",
			name: "ucenter position manage",
			redirect:'/new_system_workbench',
			component: () => import("./pages/uc_position"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_uc_position",
			name: "ucenter position legacy",
			component: () => import("./pages/roles"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_employee",
			name: "ucenter employee manage",
			redirect:'/new_system_workbench',
			component: () => import("./pages/uc_employee"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_uc_employee",
			name: "ucenter employee legacy",
			redirect:'/new_system_workbench',
			component: () => import("./pages/staff"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_pwd",
			name: "ucenter set Password",
			component: () => import("./pages/uc_pwd"),
			meta:{auth:true,authority:true}
		},

		{
			path: "/notice",
			name: "notice center",
			component: () => import("./pages/notice")
		},
		{
			path: "/notification",
			name: "notification center",
			component: () => import("./pages/messages"),
			meta:{auth:true}
		},
		{
			path: "/new_notification",
			name: "notification center legacy",
			component: () => import("./pages/notification"),
			meta:{auth:true}
		},
		{
			path: "/settle",
			name: "settlement",
			component: () => import("./pages/settle"),
			meta:{auth:true}
		},
		{
			path: "/cart",
			name: "cart",
			component: () => import("./pages/cart")
		},
		{
			path: "/vip",
			name: "vip buy",
			component: () => import("./pages/member")
		},
		{
				path: "/search_index",
				name: "search_index",
				component: () => import("./pages/search/index")
			},
		{
				path: "/search_image",
				name: "search_image",
				component: () => import("./pages/search/image")
			},
		{
			path: "/supplier",
			name: "supplier center",
			component: () => import("./pages/supplier")
		},
		{
			path: "/uc_goods2",
			name: "ucenter goods2",
			component: () => import("./pages/uc_goods2"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_order2",
			name: "asdads",
			component: () => import("./pages/uc_order2"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_after",
			name: "ucenter after",
			component: () => import("./pages/uc_after"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/collect",
			name: "collect",
			component: () => import("./pages/collect"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/search_shop",
			name: "search_shop",
			component: () => import("./pages/search/shop")
		},
		{
			path: "/freight",
			name: "freight",
			component: () => import("./pages/freight"),
			meta: {auth: true}
		},
		{
			path: "/uc_blindBox",
			name: "ucenter blindBox",
			redirect:'/new_cloud_workbench',
			component: () => import("./pages/uc_blindBox"),
			meta:{auth:true,authority:true}
		},{
			path: "/uc_blindBox_wechatEdit",
			name: "ucenter blindBox wechatEdit",
			component: () => import("./pages/uc_blindBox/wechatEdit.vue"),
			meta:{auth:true,authority:true}
		},{
			path: "/uc_product",
			name: "ucenter product",
			redirect:'/new_cloud_workbench',
			component: () => import("./pages/uc_product/index.vue"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_uc_product",
			name: "ucenter product legacy",
			component: () => import("./pages/cloudLib"),
			meta:{auth:true,authority:true}
		},{
			path: "/uc_product_details",
			name: "ucenter product details",
			redirect:'/new_cloud_workbench',
			component: () => import("./pages/uc_product/details.vue"),
			meta:{auth:true,authority:true}
		},{
			path: "/uc_check",
			name: "ucenter check",
			redirect:'/new_cloud_workbench',
			component: () => import("./pages/uc_check"),
			meta:{auth:true,authority:true}
        },{
			path: "/uc_checkSku",
			name: "ucenter skecheck",
			redirect:'/new_cloud_workbench',
			component: () => import("./pages/uc_checkSku"),
			meta:{auth:true,authority:true}
		},
        {
			path: "/uc_check_keywordLog",
			name: "ucenter check keywordLog",
			redirect:'/new_cloud_workbench',
			component: () => import("./pages/uc_check/keywordLog.vue"),
			meta:{auth:true,authority:true}
		},{
			path: "/uc_statistic",
			name: "ucenter statistic",
			redirect:'/new_finance_workbench',
			component: () => import("./pages/uc_statistic"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_statistic_product_detail",
			name: "ucenter statistic product detail",
			component: () => import("./pages/uc_statistic/product_detail.vue"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_pdd_manage",
			name: "ucenter pdd manage",
			redirect:'/new_finance_workbench',
			component: () => import("./pages/uc_pdd_manage"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_uc_pdd_manage",
			name: "ucenter pdd manage legacy",
			component: () => import("./pages/purchase"),
			meta:{auth:true,authority:true}
		},{
			path: "/uc_alienCheck",
			name: "ucenter alienCheck",
			component: () => import("./pages/uc_check/alienCheck.vue"),
			// component: () => import("./pages/uc_check/alienCheck2.vue"),
			meta:{auth:true,authority:true}
		},{
			path: "/uc_alienCheck2",
			name: "ucenter alienCheck",
			redirect:'/new_cloud_workbench',
			component: () => import("./pages/uc_check/alienCheck2.vue"),
			meta:{auth:true,authority:true}
		},{
			path: "/uc_shop_board",
			name: "ucenter shop board",
			redirect:'/new_ops_workbench',
			component: () => import("./pages/uc_shop_board"),
			meta:{auth:true,authority:true}
		},{
			path: "/uc_shop_board_detail",
			name: "ucenter shop board detail",
			redirect:'/new_ops_workbench',
			component: () => import("./pages/uc_shop_board/detail.vue"),
			meta:{auth:true,authority:true}
		},{
			path: "/uc_shop_board_detail_wechat",
			name: "ucenter shop board detail wechat",
			redirect:'/new_ops_workbench',
			component: () => import("./pages/uc_shop_board/detail_wechat.vue"),
			meta:{auth:true,authority:true}
		},{
			path: "/uc_product_board",
			name: "ucenter product board",
			redirect:'/new_ops_workbench',
			component: () => import("./pages/uc_product_board"),
			meta:{auth:true,authority:true}
		},{
			path: "/uc_task_hall",
			name: "ucenter task hall",
			redirect:'/new_ops_workbench',
			component: () => import("./pages/uc_task/hall.vue"),
			meta:{auth:true,authority:true}
		},{
			path: "/uc_task_detail",
			name: "ucenter task detail",
			redirect:'/new_ops_workbench',
			component: () => import("./pages/uc_task/detail.vue"),
			meta:{auth:true,authority:true}
		},{
			path: "/uc_after_sales",
			name: "ucenter after sales",
			redirect:'/new_aftersales_workbench',
			component: () => import("./pages/uc_after_sales"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_uc_after_sales",
			name: "ucenter after sales legacy",
			component: () => import("./pages/afterSales"),
			meta:{auth:true,authority:true}
		},{
			path: "/uc_after_sale_address",
			name: "ucenter after sale address",
			redirect:'/new_aftersales_workbench',
			component: () => import("./pages/uc_after_sale_address"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_uc_after_sale_address",
			name: "ucenter after sale address legacy",
			component: () => import("./pages/afterAddr"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/new_wx_aftersale_config",
			name: "wxshop aftersale config",
			component: () => import("./pages/wxAftersaleConfig"),
			meta:{auth:true,authority:true}
		}, {
			path: "/uc_after_sales_detail",
			name: "ucenter aftersales detail",
			component: () => import("./pages/uc_after_sales/detail"),
			meta:{auth:true,authority:true}
		},{
			path: "/uc_optimization",
			name: "ucenter optimization detail",
			redirect:'/new_cloud_workbench',
			component: () => import("./pages/uc_optimization"),
			meta:{auth:true,authority:true}
		},{
			path: "/uc_dd_host",
			name: "ucenter dd host",
			redirect:'/new_uc_shop_manage',
			component: () => import("./pages/uc_dd_host"),
			meta:{auth:true,authority:true}
		},{
			path: "/uc_reimbursement",
			name: "ucenter reimbursement",
			redirect:'/new_finance_workbench',
			component: () => import("./pages/uc_reimbursement"),
			meta:{auth:true,authority:true}
		},
        {
			path: "/uc_ticket",
			name: "ucenter ticket",
			redirect:'/new_system_workbench',
			component: () => import("./pages/uc_ticket"),
			meta:{auth:true,authority:true}
		},
        {
			path: "/uc_doudian_move_config",
			name: "doudian move config",
			component: () => import("./pages/uc_doudian_move_config"),
			meta:{auth:true,authority:true}
		},
	]
});
let permissionUserPromise = null

function ensurePermissionUser() {
	if (store.state.login.permissionsLoaded) return Promise.resolve()
	if (!permissionUserPromise) {
		permissionUserPromise = store.dispatch('login/getUserinfoData', { data: {} })
			.catch(() => null)
			.finally(() => { permissionUserPromise = null })
	}
	return permissionUserPromise
}

router.beforeEach(async (to, from, next) => {
	if (!to.name) return next('/')
	if (to.meta.guestOnly && localStorage[config.tokenKey]) return next('/ucenter')
	if (!to.meta.auth) return next()
	if (!localStorage[config.tokenKey]) return next('/')
	await ensurePermissionUser()
	const login = store.state.login
	const userinfo = login.userinfo || {}
	const legacyAccess = userinfo.access || ''
	const newUiAccess = userinfo.new_ui_access || ''

	// 新版首页是登录后的固定入口；页面内部会按权限过滤工作台和汇总数据。
	if (to.path === '/ucenter') return next()
	const workbench = getWorkbenchByRoute(to.path)

	if (workbench) {
		const allowedChildren = getAllowedChildren(workbench.id, newUiAccess, login.is_host)
		if (!allowedChildren.length) {
			return next({ path: '/ucenter', query: { permission: 'none' } })
		}
		const requested = resolveRequestedNewUiChild(workbench, to.query)
		if (requested && allowedChildren.some((item) => item.id === requested.id)) return next()
		return next(getNewUiLocation(workbench, allowedChildren[0]))
	}
	const newUiAliases = {
		'/new_uc_goods': ['goods', 'dou-mg'],
		'/new_uc_order': ['presales', 'dou-order'],
		'/new_uc_wallet': ['finance', 'wallet'],
		'/new_uc_shangjia': ['cloud', 'shelf'],
		'/new_uc_setting': ['system', 'profile'],
		'/new_uc_position': ['system', 'roles'],
		'/new_uc_employee': ['system', 'staff']
	}
	if (newUiAliases[to.path]) {
		const [workbenchId, childId] = newUiAliases[to.path]
		const allowedChildren = getAllowedChildren(workbenchId, newUiAccess, login.is_host)
		const requested = allowedChildren.find((item) => item.id === childId)
		if (requested) {
			const targetWorkbench = getWorkbenchByRoute(getFirstNewUiLocation(newUiAccess, login.is_host, workbenchId).path)
			return next(getNewUiLocation(targetWorkbench, requested))
		}
		const fallback = getFirstNewUiLocation(newUiAccess, login.is_host)
		return next(fallback || { path: '/ucenter', query: { permission: 'none' } })
	}

	if (getLegacyPermissionForPath(to.path)) {
		if (canAccessLegacyPath(to.path, legacyAccess, login.is_host)) return next()
		const firstLegacy = getFirstLegacyLocation(legacyAccess, login.is_host)
		return next(firstLegacy || { path: '/ucenter', query: { legacy_permission: 'none' } })
	}

	return next()
});
function strLink(str){
	ucmenu = localStorage['ucmenu'] ? JSON.parse(localStorage['ucmenu']) :[]
	let c = ""
	for(let i in ucmenu){
		if(str.indexOf(ucmenu[i].url) != -1){
			c = str.replace(ucmenu[i].url,"")
			break;
		}
	}
	return Boolean(c)
}
export default router;
